import { getFormatedDate } from 'helpers';
import React, { useRef } from 'react';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import '../styles.scss'
import { useAnimation } from 'hooks/useAnimation';

const ResourceContent = ({ content = [], lastUpdate, loading }) => {
    const date = getFormatedDate(lastUpdate);
    const container = useRef();
    useAnimation({
        items: ['.resources__body section', '.resources-last-update'],
        container,
        dependencies: [loading],
    })

    return (
        <div ref={container}>
            <div className="resources__body">
                {content?.map(({ content }, index) => (
                    <section key={index}>
                        <BlocksRenderer content={content} />
                    </section>
                ))}
            </div>
            <div className="description2 resources-last-update ">Last Updated: {date}</div>
        </div>
    );
};

export default ResourceContent;
